import * as React from 'react';
import {Principal} from "../types/Principal";
import {Organization} from "../api-client";

interface DentobookApplicationContextType {
    locale: string;
    setLocale: (locale: string) => void;
    principal: Principal | undefined;
    setPrincipal: (principal: Principal) => void;
    userOrganization: Organization | undefined;
    setUserOrganization: (organization: Organization) => void;
    selectSubscription: number;
    setSelectSubscription: (value: number) => void;
}

export const DentobookApplicationContext = React.createContext<DentobookApplicationContextType>({
    principal:  undefined,
    setPrincipal: () => {},
    userOrganization: undefined,
    setUserOrganization: () => {},
    locale: 'EN',
    setLocale: () => {},
    selectSubscription: 0,
    setSelectSubscription: () => {}
});